import React from 'react';
import AdminLayout from '@/components/admin/AdminLayout';
import { Settings, Shield } from 'lucide-react';
import DiscountManager from './DiscountManager';

export default function AdminSystem() {
  return (
    <AdminLayout>
      <section className="relative py-12 px-6 overflow-hidden min-h-screen">
        <div className="absolute inset-0 bg-gradient-to-br from-purple-900/20 via-black to-blue-900/20"></div>
        <div className="absolute inset-0" style={{
          backgroundImage: 'radial-gradient(circle at 50% 50%, rgba(139, 92, 246, 0.1) 0%, transparent 50%)',
        }}></div>
        <div className="max-w-7xl mx-auto relative z-10">
          <div className="mb-12">
            <div className="inline-flex items-center space-x-2 px-4 py-2 bg-purple-600/20 border border-purple-500/30 rounded-full text-sm mb-6">
              <Shield className="w-4 h-4 text-purple-400" />
              <span className="text-purple-400">Admin Access</span>
            </div>
            <h1 className="text-5xl font-bold mb-4">
              <span className="bg-gradient-to-r from-purple-400 to-blue-400 bg-clip-text text-transparent">
                System Configuration
              </span>
            </h1>
            <p className="text-xl text-gray-400">Manage system settings and configurations</p>
          </div>
          <DiscountManager />
          <div className="mt-8 bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl p-8">
            <div className="flex items-center gap-3 mb-6">
              <div className="p-3 bg-blue-600/20 rounded-lg"><Settings className="w-6 h-6 text-blue-400" /></div>
              <div><h2 className="text-2xl font-bold">Other Settings</h2><p className="text-gray-400 text-sm">Additional system configurations coming soon</p></div>
            </div>
            <div className="text-center py-8">
              <p className="text-gray-500 mb-4">Future features will include:</p>
              <ul className="space-y-2 text-gray-400 inline-block text-left">
                <li>Email configuration</li>
                <li>Payment gateway settings</li>
                <li>API key management</li>
                <li>Security settings</li>
              </ul>
            </div>
          </div>
        </div>
      </section>
    </AdminLayout>
  );
}
